import { render, staticRenderFns } from "./UpdateInfoRemaining.vue?vue&type=template&id=3c716d8b&"
import script from "./UpdateInfoRemaining.vue?vue&type=script&lang=js&"
export * from "./UpdateInfoRemaining.vue?vue&type=script&lang=js&"
import style0 from "./UpdateInfoRemaining.vue?vue&type=style&index=0&id=3c716d8b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports